import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { navForRole, navItemForPath } from './nav';

export function Topbar() {
  const { user, logout, canViewAmounts, canManageUsers } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  const current = navItemForPath(location.pathname);
  const items = navForRole(user?.role, canViewAmounts, canManageUsers);

  const roleLabel =
    user?.role === 'STAFF'
      ? 'Personnel Unifiber'
      : `Prestataire${user?.contractorName ? ' · ' + user.contractorName : ''}`;
  const initial = (user?.displayName ?? '?').charAt(0).toUpperCase();

  async function handleLogout() {
    setLoggingOut(true);
    await logout();
    navigate('/login');
  }

  return (
    <header className="flex h-16 shrink-0 items-center justify-between gap-4 border-b border-slate-200 bg-white/80 px-5 backdrop-blur">
      <div className="min-w-0">
        <h1 className="truncate text-lg font-bold text-slate-900">{current?.label ?? 'MDU Invoicing'}</h1>
        {current?.subtitle && <p className="truncate text-xs text-slate-500">{current.subtitle}</p>}
      </div>

      <div className="flex items-center gap-3">
        {/* Mobile nav (sidebar hidden < lg) */}
        <select
          aria-label="Navigation"
          value={current?.path ?? ''}
          onChange={(e) => navigate(e.target.value)}
          className="rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-sm text-slate-700 lg:hidden"
        >
          {items.map((i) => (
            <option key={i.path} value={i.path}>
              {i.label}
            </option>
          ))}
        </select>

        <div className="hidden items-center gap-2.5 sm:flex">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-gradient text-sm font-bold text-white">
            {initial}
          </div>
          <div className="leading-tight">
            <div className="text-sm font-semibold text-slate-900">{user?.displayName}</div>
            <div className="text-[11px] text-slate-500">{roleLabel}</div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleLogout}
          disabled={loggingOut}
          title="Se déconnecter"
          aria-label="Se déconnecter"
          className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors hover:bg-slate-50 hover:text-brand-rose disabled:opacity-50"
        >
          {loggingOut ? (
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-slate-300 border-t-brand-rose" />
          ) : (
            <LogOut className="h-4 w-4" />
          )}
        </button>
      </div>
    </header>
  );
}
